export const ReservationApiEndpoint = {
  cancelReservation: '/reservations/cancel/:reservationId', // DELETE: 예약 취소
  fetchReservationList: '/user-reservations', // GET: 예약 현황 조회 / POST: 예약 등록
  updateReservationInfo: '/reservations/:reservationId/modify', // 예약 정보 변경
  fetchReservationAvailableTicket: '/ticket/user-tickets/reservation', // 사용가능 이용권 조회 (예약)
  requestUseTicketChange: '/ticket/user-tickets/reservation/:reservationId', // 사용 이용권 변경 (예약)
  requestReservationChangeTicketInitCheck:
    'reservations/:reservationId/tickets', // 타임이동/ 예약변경시 사용 이용권 초기화 여부 조회
};
